import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { Button, Input } from '../components/ui';
import { ErrorState } from '../components/states';
import { requestPasswordReset } from '../api/auth';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setError('');
    try {
      await requestPasswordReset(email.trim());
      setSent(true);
    } catch {
      setError('Could not send the reset email. Check the address and try again.');
    }
  }

  return (
    <main className="workspace-main">
      <section className="panel auth-panel">
        <header className="panel-heading">
          <span className="index-label">AUTH / RESET</span>
        </header>
        <div className="panel-body">
          <h1>Reset password</h1>
          {sent ? (
            <p>If that address belongs to a user, a reset link is on its way.</p>
          ) : (
            <>
              {error && <ErrorState title="Reset failed" detail={error} />}
              <form onSubmit={onSubmit} className="auth-form">
                <label className="index-label" htmlFor="email">
                  EMAIL
                </label>
                <Input
                  id="email"
                  type="email"
                  autoComplete="username"
                  required
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
                <div className="auth-actions">
                  <Button type="submit">Send reset link</Button>
                  <Link className="auth-link" to="/login">
                    Back to sign in
                  </Link>
                </div>
              </form>
            </>
          )}
        </div>
      </section>
    </main>
  );
}
